export default function StorySection() {
  return (
    <section id="story" className="relative py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="font-mono text-xs uppercase tracking-widest text-slate-500">// Founder Pitch</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight mt-2 leading-[1.05]">
            Big couriers lost the <span className="text-kinetic">neighborhood</span>. We&apos;re taking it back.
          </h2>
          <div
            className="mt-8 h-72 border border-white/10 bg-cover bg-center"
            style={{ backgroundImage: "url(https://images.unsplash.com/photo-1727303016410-ba51309643af?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200)" }}
          />
        </div>

        <div className="lg:col-span-7 space-y-6 text-slate-300 leading-relaxed text-base sm:text-lg">
          <Block
            step="01"
            title="The problem"
            body="Local shops in our city spend 30% of their margin shipping with national carriers that treat them like line items. Pickups get missed. Returns get stuck in warehouses. Customers blame the shop."
          />
          <Block
            step="02"
            title="What Rally does"
            body="A founder-run courier network built around named routes and named drivers. Shops book a slot, we show up, we handle the handshake. Software tracks every leg so nothing goes dark."
          />
          <Block
            step="03"
            title="What this fundraise buys"
            body="Three electric vans, one neighborhood dispatch hub, driver training, and 90 days of operating runway so we can get Rally to profitable on route-one before raising a dollar more."
          />
          <Block
            step="04"
            title="Why I need you"
            body="This isn't a VC round. It's a believer round. Every backer gets their name on the first van's door, early customer credit, or a seat at the launch dinner. Pledges without payment also count — they help us prove demand to our first operating lender."
          />
        </div>
      </div>
    </section>
  );
}

function Block({ step, title, body }) {
  return (
    <div className="border-l-2 border-kinetic/60 pl-6">
      <div className="font-mono text-[10px] uppercase tracking-widest text-kinetic">STEP {step}</div>
      <div className="font-display font-bold text-xl sm:text-2xl text-white mt-1">{title}</div>
      <p className="mt-2 text-slate-300">{body}</p>
    </div>
  );
}
